import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Play, BookOpen, Upload } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function QueueEmptyState() {
  const { t } = useTranslation('common');

  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-16 text-center">
        <div className="rounded-full bg-muted p-4 mb-4">
          <Play className="h-8 w-8 text-muted-foreground" />
        </div>
        
        <h3 className="text-lg font-semibold mb-2">{t('queue.empty.title')}</h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          {t('queue.empty.description')}
        </p>
        
        <div className="flex gap-3">
          <Button asChild>
            <Link to="/cases/new">
              <Upload className="h-4 w-4 mr-2" />
              {t('queue.empty.startAnalysis')}
            </Link>
          </Button>
          
          <Button variant="outline" asChild>
            <Link to="/support">
              <BookOpen className="h-4 w-4 mr-2" />
              {t('queue.empty.learnMore')}
            </Link>
          </Button>
        </div>
        
        <div className="mt-8 text-xs text-muted-foreground">
          {t('queue.empty.note')}
        </div>
      </CardContent>
    </Card>
  );
}